import { FunctionComponent, useMemo } from 'react';
import { getAuthUrl } from 'utils/url-generator';
import {
  CommunityApp,
  CommunityNavigation,
  LoggedInUser,
} from '@atlassian/learning-components';
import useLoggedInUser from 'utils/useLoggedInUser';
import useIsLoggedIn from 'utils/useIsLoggedIn';
import { css } from '@compiled/react';
import {
  CommunityAnalyticsClient,
  eventType,
} from '@atlassian/community-library';
import { championsIsActive } from 'services/statsig/featureGates';

export const NavBar: FunctionComponent = () => {
  const currentUrl = globalThis?.location?.href ?? window?.location?.href ?? '';

  let updatedUrl;
  // temporary fix: conx-700
  if (currentUrl.includes('/settings')) {
    const url = new URL(currentUrl);
    url.searchParams.delete('errorCode');
    updatedUrl = `${url.origin}${url.pathname}${url.search}`;
  } else {
    updatedUrl = currentUrl;
  }

  const currentPage = encodeURIComponent(updatedUrl);
  const { accountId, name, picture, email } = useLoggedInUser() || {};
  const isLoggedIn = useIsLoggedIn();
  const normalizedUser: LoggedInUser = {
    id: accountId || '',
    publicName: name || '',
    avatar: picture,
  };

  const loginHref = useMemo(
    () =>
      getAuthUrl('login', {
        experience: 'entry-auth',
        email: email || '',
        redirectUrl: currentPage,
      }),
    [currentPage],
  );
  const logoutHref = useMemo(
    () =>
      getAuthUrl('logout', {
        experience: 'entry-auth',
        email: email || '',
        redirectUrl: currentPage,
      }),
    [currentPage],
  );
  const signupHref = useMemo(
    () =>
      getAuthUrl('signup', {
        experience: 'entry-auth',
        email: email || '',
        redirectUrl: currentPage,
      }),
    [currentPage],
  );

  return (
    <>
      <CommunityNavigation
        currentApp={CommunityApp.PROFILE}
        isLoggedIn={isLoggedIn}
        user={normalizedUser}
        loginHref={loginHref}
        logoutHref={logoutHref}
        signupHref={signupHref}
        showChampions={championsIsActive()}
        onAnalyticsSendEvent={(type, payload) =>
          CommunityAnalyticsClient.sendEvent(
            type as unknown as eventType,
            payload,
          )
        }
        email={email || ''}
      />
      <div css={navbarSpacer}> </div>
    </>
  );
};

// Fixes issue of navbar covering 'Back to profile' on 'View all' views
const navbarSpacer = css({
  marginBottom: '55px',
});
